export default {
  creditCalculation: {
    formulaTypeNo: '公式编码',
    formulaTypeNoPlaceholder: '请输入公式编码',
    formulatType: '公式类型',
    formulatTypePlaceholder: '请输入公式类型',
    partenerType: '合作伙伴类型',
    partenerTypePlaceholder: '请选择合作伙伴类型',
    calculationFactorNo: '因子编码',
    calculationFactorName: '因子名称',
    calculationFactorStatus: '因子状态',
    calculationFactorNoPlaceholder: '因子编码',
    calculationFactorNamePlaceholder: '因子名称',
    formula: '计算公式',
    formulaPlaceholder: '请输入计算公式',
    formulaStatus: '公式状态',
    controlareaName: '事业部',
    msg: {
      addData: '请新增数据后再保存',
    },
  },
};
